/**
 * @generated SignedSource<<788dc35f1a19ca0d0676e86ccb3b6cbe>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveNotificationRuleInput = {
  uuid: any;
};
export type RemoveNotificationRuleMutation$variables = {
  input: RemoveNotificationRuleInput;
};
export type RemoveNotificationRuleMutation$data = {
  readonly removeNotificationRule: {
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly removed: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type RemoveNotificationRuleMutation = {
  response: RemoveNotificationRuleMutation$data;
  variables: RemoveNotificationRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveNotificationRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RemoveNotificationRulePayload",
        "kind": "LinkedField",
        "name": "removeNotificationRule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemovedNode",
            "kind": "LinkedField",
            "name": "removed",
            "plural": false,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "RemoveNotificationRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RemoveNotificationRulePayload",
        "kind": "LinkedField",
        "name": "removeNotificationRule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemovedNode",
            "kind": "LinkedField",
            "name": "removed",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "34d2c369c851b9162448ad8aa353d61f",
    "id": null,
    "metadata": {},
    "name": "RemoveNotificationRuleMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveNotificationRuleMutation(\n  $input: RemoveNotificationRuleInput!\n) {\n  removeNotificationRule(input: $input) {\n    problems {\n      __typename\n      message\n    }\n    removed {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e9aa49e25f049174024bce741379c89e";

export default node;
